module.exports = __webpack_public_path__ + "static/media/our_process_icons.3692dbec.svg";